import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import { Card, Text, Chip, useTheme } from 'react-native-paper';

const MenuItem = ({ item, onPress }) => {
  const theme = useTheme();

  return (
    <Card style={styles.card} onPress={onPress}>
      {item.imageUrl && (
        <Card.Cover 
          source={{ uri: item.imageUrl }} 
          style={styles.image}
          resizeMode="cover"
        />
      )}
      
      <Card.Content style={styles.content}>
        <View style={styles.header}>
          <Text style={styles.title}>{item.name}</Text>
          
          <View style={styles.priceContainer}>
            <Text style={styles.price}>{item.price} TL</Text>
          </View>
        </View>
        
        {item.description && (
          <Text style={styles.description} numberOfLines={2}>
            {item.description}
          </Text>
        )}
        
        <View style={styles.tagsContainer}>
          {item.isFeatured && (
            <Chip 
              style={[styles.chip, { backgroundColor: theme.colors.primary }]} 
              textStyle={{ color: 'white' }}
            >
              Öne Çıkan
            </Chip>
          )}
          
          {!item.isAvailable && (
            <Chip 
              style={[styles.chip, { backgroundColor: theme.colors.error }]} 
              textStyle={{ color: 'white' }}
            >
              Stokta Yok
            </Chip>
          )}
          
          {item.menuCategory && (
            <Chip 
              style={[styles.chip, { backgroundColor: theme.colors.secondary }]}
              textStyle={{ color: 'white' }}
            >
              {item.menuCategory.name}
            </Chip>
          )}
        </View>
      </Card.Content>
    </Card>
  );
};

const styles = StyleSheet.create({
  card: {
    marginVertical: 8,
    marginHorizontal: 12,
    elevation: 2,
  },
  image: {
    height: 150,
  },
  content: {
    paddingVertical: 10,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    flex: 1,
  },
  priceContainer: {
    backgroundColor: '#F8F8F8',
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
  },
  price: {
    fontWeight: 'bold',
    fontSize: 14,
  },
  description: {
    color: '#666',
    fontSize: 14,
    marginBottom: 10,
  },
  tagsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 6,
  },
  chip: {
    marginRight: 6,
    marginBottom: 6,
  },
});

export default MenuItem;
